import { htmlPropsRegex } from './html-props.js';
import { memoize } from './memoize.js';

const isHtmlPropValid = /* #__PURE__ */memoize(prop => htmlPropsRegex.test(prop) || prop.charCodeAt(0) === 111 /* o */ && prop.charCodeAt(1) === 110 /* n */ && prop.charCodeAt(2) < 91 /* Z+1 */);

export { isHtmlPropValid };
